module.exports = __webpack_public_path__ + "static/img/game8.e88764fc.png";